import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { onUnreadCount, unreadCount } from '../lib/unread';
import './ChatLink.css';

/**
 * The way into chat, with the number of unread messages on it.
 *
 * Gordon: "in the menu bar - on top of the chat menu item put in the number of
 * unread messages received."
 *
 * IN A COMPONENT BECAUSE IT IS NEEDED IN TWO PLACES, and the second one is the
 * bug he reported. The navbar is hidden on the contractor portal pages
 * entirely, so a Chat item in the navbar alone is invisible to a contractor
 * sitting on their own dashboard - which is where a contractor always is. The
 * dashboard's own header carries what a navbar would, so it carries this too.
 *
 * The count comes from lib/unread, which the notifications bell fills from a
 * poll it was already making. So the badge costs no extra request and cannot
 * disagree with the bell next to it.
 */
const Badge = () => {
  const [n, setN] = useState(unreadCount);
  // The store notifies only on a real change, so this re-renders when the
  // number moves and not on every poll.
  useEffect(() => onUnreadCount(setN), []);
  if (n <= 0) return null;
  return (
    <span className="chat-badge" aria-label={`${n} unread message${n === 1 ? '' : 's'}`}>
      {n > 99 ? '99+' : n}
    </span>
  );
};

/** For the navbar's <ul>. */
export const ChatNavItem = () => (
  <li>
    <NavLink to="/chat" className="chat-link">
      Chat
      <Badge />
    </NavLink>
  </li>
);

/** For anywhere that is not a list - the contractor dashboard's own header. */
export const ChatButtonLink = ({ label = 'Chat' }) => (
  <NavLink to="/chat" className="chat-link chat-link-standalone">
    {label}
    <Badge />
  </NavLink>
);

/**
 * Chat as an icon, for the narrow top bar beside the Menu button.
 *
 * Gordon: "on mobile view ... create a chat icon next to the menu pls and
 * remove from the menu drop down." Chat is the thing people open most on a
 * phone, so it is one tap from any screen rather than two (Menu, then Chat),
 * and it carries the unread count where it is seen. App.css shows it only
 * when the Menu button shows.
 */
export const ChatIconLink = () => (
  <NavLink to="/chat" className="nav-chat-icon" aria-label="Chat" title="Chat">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
      strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.6A8 8 0 1 1 21 12z" />
    </svg>
    <Badge />
  </NavLink>
);

export default ChatNavItem;
